import styled, { css } from 'styled-components';

export const Container = styled.ul(
  ({ theme }) => css`
    margin: 0;
    width: 100%;
    padding: 0 ${theme.sz.s4};
    min-width: 100%;
  `,
);

export const ToastWrapper = styled.div(
  ({ theme }) => css`
    position: absolute;
    z-index: ${theme.zi.modal};
    top: ${theme.sz.s16};
    transform: translateX(-50%);
    left: 50%;
  `,
);
